import { render } from "./SideBar.vue?vue&type=template&id=d534cc00&scoped=true"
import script from "./sidebar.view.js?vue&type=script&lang=js&external"
export * from "./sidebar.view.js?vue&type=script&lang=js&external"

import "./sidebar.css?vue&type=style&index=0&id=d534cc00&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d534cc00"]])

export default __exports__